// extracted by mini-css-extract-plugin
export var card = "Column-module--card--43840";
export var count = "Column-module--count--f5679";
export var label = "Column-module--label--c415b";
export var withLabel = "Column-module--withLabel--e903b";